import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Tabs, Tab } from '@material-ui/core';
import translate from '../../i18next/funcTranslateHelper';

const SearchNav = ({
  hashType,
  handleChange,
  hashPlaceholder,
  origin
}) => {
  const useStyles = makeStyles(() => ({
    root: {
      height: '40px !important',
      marginTop: origin === 'searcher' ? 40 : 14,
      minHeight: '40px !important'
    },
    flexContainer: {
      flexDirection: 'row'
    }
  }));

  const useTabsStyles = makeStyles(theme => ({
    root: {
      fontFamily: 'Roboto-Light',
      color: origin === 'searcher' ? '#FFFFFF' : '#6F6F6F',
      letterSpacing: '0px',
      textAlign: 'left',
      paddingBottom: '0px',
      textTransform: 'none',
      minWidth: 33,
      paddingLeft: '0px',
      [theme.breakpoints.up('md')]: {
        paddingRight: 44,
        fontSize: 18
      },
      [theme.breakpoints.up('sm')]: {
        paddingRight: 44,
        fontSize: 18
      },
      [theme.breakpoints.down('sm')]: {
        paddingRight: 20
      },
      '&:hover': {
        outline: 'none',
        opacity: 1,
        border: 'none'
      },
      '&:focus': {
        outline: 'none',
        opacity: 1,
        border: 'none'
      }
    },
    selected: {
      fontWeight: 'bold',
      letterSpacing: '0px',
      textAlign: 'left',
      textTransform: 'none',
      color: origin === 'searcher' ? '#FFFFFF' : '#6F6F6F'
    },
    selectedWrapper: {
      display: 'inline-block',
      width: 'auto',
      color: origin !== 'searcher' && '#CA005A'
    },
    wrapper: {
      display: 'inline-block',
      width: 'auto'
    }
  }));
  const [doneOnce, setDoneOnce] = useState(false);
  const classesTab = useStyles();
  const classesTabs = useTabsStyles();
  const tabsArray = ['hash', 'transaction', 'identity', 'contract', 'asset'];

  useEffect(() => {
    return () => {
      if (!doneOnce) {
        setTimeout(() => {
          setDoneOnce(true);
        }, 100);
      }
    };
  }, [hashType, doneOnce]);

  return (
    <div>
      <Tabs
        value={hashType}
        onChange={handleChange}
        TabIndicatorProps={{
          style: {
            display: origin !== 'searcher' && 'none',
            width: '30px',
            height: '2px',
            background:
          origin === 'searcher'
            ? '#FFFFFF'
            : 'linear-gradient(226deg, #F96500 0% , #CA005A 100%)'
          }
        }}
        classes={{
          root: classesTab.root,
          flexContainer: classesTab.flexContainer
        }}
      >
        {tabsArray.map(item => (
          <Tab
            key={`${item}`}
            disableRipple
            label={translate(`Trazer:searchNav:${item}`)}
            value={`${item}`}
            classes={{
              root: classesTabs.root,
              selected: classesTabs.selected,
              wrapper: hashType === item ? classesTabs.selectedWrapper : classesTabs.wrapper
            }}
          />
        ))}
      </Tabs>
    </div>
  );
};

export default SearchNav;
